import { createContext } from "react";
import { QueryClient } from "@tanstack/react-query";
import type { Account, Row } from "./client";

// Keep identity-bearing objects outside the refreshable provider module.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false, staleTime: 20_000 },
  },
});
export type Session = {
  token: string;
  account: Account | null;
  setAccount: (account: Account | null) => void;
  login: (token: string) => void;
  logout: () => void;
  request: <T = Row>(path: string, options?: RequestInit) => Promise<T>;
  scope: string;
};
export const SessionContext = createContext<Session>(null!);
